import { partition } from 'lodash';
import type { ServerImagesDiff } from '../types';

export const diffAgainstServerImages = (
  files: File[],
  uploadedImageNames: string[],
): ServerImagesDiff => {
  const uploadedImageNameSet = new Set(uploadedImageNames);
  const [onServer, remaining] = partition(files, (file) =>
    uploadedImageNameSet.has(file.name),
  );

  return { onServer, remaining };
};
